module.exports = __webpack_public_path__ + "static/netflix-ccxp-3-8cf6dc0dd3c7bd13e4f3f30667106a06.jpg";